/**
 * Instruction shape helpers (attributes.agentName, meta) match API/GraphQL AssistantAttributes.
 * Used by ChatUI, DynamicRenderer, and any consumer that needs "last response" context.
 */

/**
 * Get the last (assistant) response's agent name and meta from the instructions array.
 * Agent-agnostic; no Blueprint or other agent-specific logic.
 *
 * @param {Array<object>} instructions - Array of instruction objects (id, attributes, meta, ...)
 * @returns {{ agentName: string|undefined, meta: object }|null} Last instruction's agentName and meta, or null if empty/invalid
 */
export function getLastResponseFromInstructions(instructions) {
  if (!Array.isArray(instructions) || instructions.length === 0) {
    return null;
  }
  const last = instructions.at(-1);
  const attrs = last?.attributes ?? {};
  const meta = last?.meta ?? {};
  return {
    agentName: attrs.agentName,
    meta
  };
}
